export const SHOW_SESSION_WARNING = `auth/SHOW_SESSION_WARNING`;
export const HIDE_SESSION_WARNING = `auth/HIDE_SESSION_WARNING`;

export const FETCH_LOGIN_REQUEST = 'auth/FETCH_LOGIN_REQUEST';
export const FETCH_LOGIN_SUCCESS = 'auth/FETCH_LOGIN_SUCCESS';
export const FETCH_LOGIN_FAILURE = 'auth/FETCH_LOGIN_FAILURE';

export const FETCH_LOGOUT_REQUEST = 'auth/FETCH_LOGOUT_REQUEST';
export const FETCH_LOGOUT_SUCCESS = 'auth/FETCH_LOGOUT_SUCCESS';
export const FETCH_LOGOUT_FAILURE = 'auth/FETCH_LOGOUT_FAILURE';

export const FETCH_RENEW_SESSION_REQUEST = 'auth/FETCH_RENEW_SESSION_REQUEST';
export const FETCH_RENEW_SESSION_SUCCESS = 'auth/FETCH_RENEW_SESSION_SUCCESS';
export const FETCH_RENEW_SESSION_FAILURE = 'auth/FETCH_RENEW_SESSION_FAILURE';

export const MANAGE_SESSION_TIMEOUT = 'auth/MANAGE_SESSION_TIMEOUT';

export const LOGGED_IN = 'auth/LOGGED_IN';
export const LOGGED_OFF = 'auth/LOGGED_OFF';
